import { BsGridFill } from 'react-icons/bs';
import { TiThList } from 'react-icons/ti';

const prefix = 'BRANCH/SERVICES/ORDER_TAKER/ORDER';

export const GET_PRODUCTS = `${prefix}/GET_PRODUCTS`;
export const GET_SELECTED_PRODUCT = `${prefix}/GET_SELECTED_PRODUCT`;
export const GET_CATEGORIES = `${prefix}/GET_CATEGORIES`;
export const GET_DRAFT_LIST = `${prefix}/GET_DRAFT_LIST`;
export const GENERATE_DRAFT = `${prefix}/GENERATE_DRAFT`;

const ADS = () => <div className="text-xs font-bold">ADS</div>;

export const LAYOUT_OPTS = [
  {
    label: 'Grid',
    value: 'GRID',
    icon: BsGridFill,
  },
  {
    label: 'Row',
    value: 'ROW',
    icon: TiThList,
  },
  {
    label: 'Ads',
    value: 'ADS',
    icon: ADS,
  },
];
